import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { TicketRequest } from "@proto/mypascom";
import { ProtobufService } from "../protobuf.service";
import { AddMessageConversationEntryResponse, CloseTicketResponse, CreateTicketResponse, GetTicketAttachmentDownloadUrlResponse, GetTicketDetailResponse, GetTicketListResponse, TicketState } from "@proto/hubspotr";

@Injectable({ providedIn: 'root' })
export class SupportV2Service {

    private readonly baseUrl = '/services/v2/support/ticket';

    constructor(private protoService: ProtobufService) {
    }

    getAllTickets(req: TicketRequest): Observable<GetTicketListResponse> {
        return this.protoService.post(
            this.baseUrl,
            TicketRequest.encode(req),
        ).pipe(
            map(response => {
                return GetTicketListResponse.decode(response);
            })
        );
    }

    getTicketDetails(req: TicketRequest): Observable<GetTicketDetailResponse> {
        return this.protoService.post(
            `${this.baseUrl}/detail`,
            TicketRequest.encode(req),
        ).pipe(
            map(response => {
                return GetTicketDetailResponse.decode(response);
            })
        );
    }

    createTicket(req: TicketRequest): Observable<CreateTicketResponse> {
        return this.protoService.post(
            `${this.baseUrl}/create`,
            TicketRequest.encode(req),
        ).pipe(
            map(response => {
                return CreateTicketResponse.decode(response);
            })
        );
    }

    addMessage(req: TicketRequest): Observable<AddMessageConversationEntryResponse> {
        return this.protoService.post(
            `${this.baseUrl}/add-message`,
            TicketRequest.encode(req),
        ).pipe(
            map(response => {
                return AddMessageConversationEntryResponse.decode(response);
            })
        );
    }

    getAttachmentDownloadUrl(req: TicketRequest): Observable<GetTicketAttachmentDownloadUrlResponse> {
        return this.protoService.post(
            `${this.baseUrl}/asset/prepare-download`,
            TicketRequest.encode(req),
        ).pipe(
            map(response => {
                return GetTicketAttachmentDownloadUrlResponse.decode(response);
            })
        );
    }

    closeTicket(req: TicketRequest): Observable<CloseTicketResponse> {
        return this.protoService.post(
            `${this.baseUrl}/close`,
            TicketRequest.encode(req),
        ).pipe(
            map(response => {
                return CloseTicketResponse.decode(response);
            })
        );
    }

    getTicketStateTranslationKey(state: TicketState): string {
        switch (state) {
          case TicketState.STATE_UNKNOWN:
            return 'support_ticket_state_unknown'
          case TicketState.STATE_WAIT_ON_CONTACT:
            return 'support_ticket_state_wait_on_contact'
          case TicketState.STATE_WAIT_ON_US:
            return 'support_ticket_state_wait_on_us'
          case TicketState.STATE_WAIT_ON_DEV:
            return 'support_ticket_state_wait_on_dev'
          case TicketState.STATE_WAIT_ON_APPOINTMENT:
            return 'support_ticket_state_wait_on_appointment'
          case TicketState.STATE_WAIT_ON_CLOSE:
            return 'support_ticket_state_wait_on_close'
          case TicketState.STATE_CLOSED:
            return 'support_ticket_state_closed'
          case TicketState.UNRECOGNIZED:
            return 'support_ticket_state_unrecognized'
          default:
          case TicketState.STATE_NEW:
            return 'support_ticket_state_new'
        }
    }
}